import styled from "@emotion/styled"
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material"
import { ArrowDown } from "ui"
import { extractProperty } from "utils"
import SectionTitles from "./SectionTitles"

type Props = {
  title: string
  subtitle: string
  allBuildings: any
  fileManagementSteps: any
  selectedBuilding: any
  handleBuildingChange: any
}

const StyleDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 40px;
  padding-top: 20px;
  .MuiFormControl-root {
    width: 100%;
    ${(props) => props.theme.breakpoints.up("md")} {
      width: 328px;
    }
  }
  .MuiSelect-icon {
    top: calc(50% - 12px);
    right: 8px;
  }
`
const BuildingSelection = ({
  title,
  subtitle,
  allBuildings,
  fileManagementSteps,
  selectedBuilding,
  handleBuildingChange,
}: Props) => {
  // Get available building names from file management steps
  const getAvailableBuildingNames = () => {
    if (!fileManagementSteps || !Array.isArray(fileManagementSteps)) return []

    const names = new Set<string>()

    fileManagementSteps.forEach((file: any) => {
      const buildingSelection = extractProperty(file, "buildingSelection")?.[0]
      const buildingSelectionValue = extractProperty(buildingSelection, "BuildingSelection")

      if (Array.isArray(buildingSelectionValue)) {
        buildingSelectionValue.forEach((building: any) => {
          if (building.name) {
            names.add(building.name)
          }
        })
      }
    })

    return Array.from(names)
  }

  // Filter buildings to only show those available in file management steps
  const availableBuildingNames = getAvailableBuildingNames()
  const filteredBuildings = allBuildings.filter((building: any) =>
    availableBuildingNames.includes(building.name),
  )

  return (
    <StyleDiv>
      <SectionTitles title={title} subtitle={subtitle} />
      <FormControl>
        <InputLabel id="demo-simple-select-label">{title}</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={selectedBuilding}
          label="Age"
          onChange={handleBuildingChange}
          IconComponent={ArrowDown}
          MenuProps={{
            PaperProps: {
              sx: {
                paddingBottom: "16px",
                borderBottomRightRadius: "8px",
                borderBottomLeftRadius: "8px",
                height: "195px",
                "& .MuiMenuItem-root": {
                  padding: 2,
                  fontSize: "18px",
                  borderBottom: "1px solid #6F6F6F",
                },
                // Scrollbar styling
                "&::-webkit-scrollbar": {
                  width: "5px",
                },
                "&::-webkit-scrollbar-button": {
                  display: "none",
                },
                "&::-webkit-scrollbar-track": {
                  backgroundColor: "transparent",
                },
                "&::-webkit-scrollbar-thumb": {
                  backgroundColor: "#2768A3",
                  borderRadius: "4px",
                  "&:hover": {
                    backgroundColor: "rgba(255, 255, 255, 0.7)",
                  },
                },
              },
            },
          }}
        >
          {filteredBuildings.map((building: any, index: number) => {
            const buildingName = extractProperty(building, "buildingName")
            return (
              <MenuItem value={building.id} key={index}>
                {buildingName}
              </MenuItem>
            )
          })}
        </Select>
      </FormControl>
    </StyleDiv>
  )
}

export default BuildingSelection
